"use client";

import { useCallback } from "react";
import { clientApi } from "@frontend/lib/api";
import { usePollRefresh } from "@frontend/lib/use-poll-refresh";

/** Polls the inbox list fingerprint and reloads only the inbox data. */
export function CollabInboxSync({
  revision,
  onChange,
}: {
  revision: string;
  onChange: () => void;
}) {
  const fetchRevision = useCallback(async () => {
    const data = await clientApi<{ revision: string }>("/api/collabs/inbox/sync");
    return data.revision;
  }, []);

  usePollRefresh(revision, fetchRevision, { onChange });
  return null;
}
